import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
// import registerServiceWorker from './registerServiceWorker'
import moment from 'moment'
import message from './locales/pt-BR'

import store from './store/configureStore'

moment.locale('pt-br', message.moment)

ReactDOM.render(<App store={store} />, document.getElementById('root'))
/*
if (process.env.NODE_ENV !== 'production') {
  // eslint-disable-next-line no-unused-vars,react/no-deprecated
  let createClass = React.createClass
  Object.defineProperty(React, 'createClass', {
    set: (nextCreateClass) => {
      createClass = nextCreateClass
    }
  })
  // eslint-disable-next-line global-require
  const { whyDidYouUpdate } = require('why-did-you-update')
  whyDidYouUpdate(React)
}
*/
// registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js